export default __webpack_public_path__ + "static/starPythagoras-590fda74aa120fa918386621a13c690b.png";